import progressBar from '../modules/progressBar';
import sendForm from '../modules/sendForm';
import activeMenuInternal from '../modules/activeMenuInternal';

activeMenuInternal();
sendForm();
progressBar();